export default __webpack_public_path__ + "static/media/instructions-new-shape.1dac84f3.png";